import { useMemo } from 'react';

// Put initialState into a getter
export const useStoreOptions = (initialState: any, _isPageSSRd: boolean): any => {
	return useMemo(() => {
		const result: any = {};

		if (initialState) {
			result.storeOptions = {
				initialState,
			};
		}

		return result;
	}, [initialState]);
};
